import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/styles/makeStyles'
import React, { useContext, useEffect, useState } from 'react'

import colorContext from '../../Context/colorContext'
import {
  loadPendingTermSISECI,
  signTermSISECI,
} from '../../services/temosSISECI'
import { loadPendingTermSSO, signTermSSO } from '../../services/temosSSO'

export interface ITermSSO {
  id: string
  titulo: string
  versao: string
  texto: string
}
export interface ITermsSISECI {
  id: string
  titulo: string
  versao: string
  texto: string
}

interface TermoDialogProps {
  handleCloseTerm?: (isAcceptedTerm?: boolean) => void
}

export default function TermoDialog({
  handleCloseTerm,
}: TermoDialogProps): JSX.Element {
  const { colors } = useContext(colorContext)

  const useStyles = makeStyles(() => ({
    root: {
      backgroundColor: colors.colorBackground,
    },
    titleBox: {
      textAlign: 'center',
      backgroundColor: colors.colorWithoutGradient,
      padding: 20,
      color: colors.textAccentColor,
    },
    boxTextTermo: {
      border: `1px solid ${colors.borderShadowsColor}`,
      padding: 10,
      height: '50vh',
      overflow: 'auto',
      color: colors.textBody,
    },
    footerTermo: {
      display: 'flex',
      padding: 20,
      justifyContent: 'space-between',
      backgroundColor: colors.colorBackground,
    },
    btnRecusar: {
      width: '45%',
      padding: 10,
      color: colors.textBody,
      '&:hover': {
        backgroundColor: colors.colorBackgroundSecundary,
        color: colors.textAccentColor,
      },
    },
    textRecusar: {
      textDecoration: 'underline',
    },
    btnAceitar: {
      backgroundColor: colors.buttonSuccessColor,
      color: colors.colorBackgroundSecundary,
      width: '45%',
      padding: 10,
      '&:hover': {
        backgroundColor: colors.buttonSuccessColor,
      },
    },
    btnAceitando: {
      backgroundColor: colors.buttonSuccessColor,
      color: colors.colorBackgroundSecundary,
      width: '100%',
      padding: 10,
      '&:hover': {
        backgroundColor: colors.buttonSuccessColor,
      },
    },
    subTitle: {
      color: colors.textBody,
    },
  }))
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const [penddingTermsSSO, setPenddingTermsSSO] = useState<ITermSSO[]>([])
  const [penddingTermsSISECI, setPenddingTermsSISECI] = useState<
    ITermsSISECI[]
  >([])
  const [loadingSignTerm, setLoadingSignTerm] = useState<boolean>(false)
  const [sisTermCurrent, setSisTermCurrent] = useState<string>('')

  const token: string | null = localStorage.getItem('gov_access_token_sso')
  const tokenSiseci: string | null = localStorage.getItem(
    'gov_access_token_siseci',
  )

  const handleClose = () => {
    const isFunctionValid = !!handleCloseTerm
    if (isFunctionValid) {
      handleCloseTerm()
    }
    setOpen(false)
  }

  const currentPenndingTermSISECI = async () => {
    try {
      const { data } = await loadPendingTermSISECI(tokenSiseci || '')
      setPenddingTermsSISECI(data)
      if (data.length) {
        setSisTermCurrent('SERVIÇOS')
        setOpen(true)
      }
    } catch (error) {
      setPenddingTermsSISECI([])
      console.log('erro ao carregar termo siseci', error)
    }
  }

  const currentPenndingTermSSO = async () => {
    try {
      const { data } = await loadPendingTermSSO(token || '')
      setPenddingTermsSSO(data)
      if (data.length) {
        setSisTermCurrent('SSO')
        setOpen(true)
      } else if (tokenSiseci) {
        currentPenndingTermSISECI()
      }
    } catch (error) {
      setPenddingTermsSSO([])
      console.log('erro ao carregar termo sso', error)
      currentPenndingTermSISECI()
    }
  }

  const signAllTermSSO = () => {
    setLoadingSignTerm(true)
    try {
      penddingTermsSSO.forEach(({ id }) => {
        signTermSSO(token || '', id)
      })
      setOpen(false)
      setLoadingSignTerm(false)
      currentPenndingTermSISECI()
    } catch (error) {
      console.log(error)
      setLoadingSignTerm(false)
      setOpen(false)
    }
  }

  const signAllTermSISECI = () => {
    setLoadingSignTerm(true)
    try {
      penddingTermsSISECI.forEach(({ id }) => {
        signTermSISECI(tokenSiseci || '', id)
      })
      setOpen(false)
      setLoadingSignTerm(false)
    } catch (error) {
      console.log(error)
      setLoadingSignTerm(false)
      setOpen(false)
    }
  }

  const handleSignTermsSSO = () => {
    signAllTermSSO()
  }
  const handleSignTermsSISECI = () => {
    signAllTermSISECI()
  }

  useEffect(() => {
    if (token) {
      currentPenndingTermSSO()
    }
    // if (tokenSiseci) {
    //   currentPenndingTermSISECI();
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title" className={classes.titleBox}>
          <Typography>{`TERMOS DE ACEITE ${sisTermCurrent}`}</Typography>
        </DialogTitle>
        <DialogContent classes={{ root: classes.root }}>
          <div className={classes.boxTextTermo}>
            {sisTermCurrent === 'SSO' ? (
              <>
                {penddingTermsSSO?.length ? (
                  <>
                    {penddingTermsSSO.map(({ id, titulo, versao, texto }) => (
                      <Box key={id}>
                        <Typography
                          variant="h4"
                          component="h2"
                          className={classes.subTitle}
                        >
                          {titulo} - Versão ({versao})
                        </Typography>
                        <Box dangerouslySetInnerHTML={{ __html: texto }} />
                      </Box>
                    ))}
                  </>
                ) : (
                  ''
                )}
              </>
            ) : (
              ''
            )}

            {sisTermCurrent === 'SERVIÇOS' ? (
              <>
                {penddingTermsSISECI?.length ? (
                  <>
                    {penddingTermsSISECI.map(
                      ({ id, titulo, versao, texto }) => (
                        <Box key={id}>
                          <Typography
                            variant="h4"
                            component="h2"
                            className={classes.subTitle}
                          >
                            {titulo} - Versão ({versao})
                          </Typography>
                          <Box dangerouslySetInnerHTML={{ __html: texto }} />
                        </Box>
                      ),
                    )}
                  </>
                ) : (
                  ''
                )}
              </>
            ) : (
              ''
            )}
          </div>
        </DialogContent>
        <Box className={classes.footerTermo}>
          {!loadingSignTerm ? (
            <>
              <Button
                onClick={handleClose}
                color="primary"
                className={classes.btnRecusar}
              >
                <Typography className={classes.textRecusar}>Recusar</Typography>
              </Button>

              {sisTermCurrent === 'SSO' ? (
                <Button
                  onClick={handleSignTermsSSO}
                  style={{
                    border: `1px solid ${colors.borderShadowsColor}`,
                    backgroundColor: colors.buttonSuccessColor,
                    width: '45%',
                    padding: 10,
                  }}
                >
                  <Typography>Aceitar</Typography>
                </Button>
              ) : (
                ''
              )}

              {sisTermCurrent === 'SERVIÇOS' ? (
                <Button
                  onClick={handleSignTermsSISECI}
                  style={{
                    backgroundColor: colors.buttonSuccessColor,
                    width: '45%',
                    padding: 10,
                  }}
                >
                  <Typography>Aceitar</Typography>
                </Button>
              ) : (
                ''
              )}
            </>
          ) : (
            <Button color="primary" className={classes.btnAceitando} disabled>
              <Typography>
                Aceitando {'  '}
                <CircularProgress size={10} />
              </Typography>
            </Button>
          )}
        </Box>
      </Dialog>
    </div>
  )
}
